const addToCart = () => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('estimatedDelivery', () => ({
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      earliestDate: null,
      latestDate: null,
      addWorkingDays(startDate, daysToAdd) {
        let currentDate = new Date(startDate);
        let currentHour = currentDate.getUTCHours();
        let currentMinutes = currentDate.getUTCMinutes();

        // if date falls within summer time, add 1 hour
        if (currentDate.getMonth() > 2 && currentDate.getMonth() < 9) {
          currentHour += 1;
        }

        // If the current time is after 16:30 (UTC) add a day
        if (currentHour > 16 || (currentHour === 16 && currentMinutes >= 30)) {
          currentDate.setDate(currentDate.getDate() + 1);

          // if it's a saturday or sunday - we don't dispatch on weekends
          if (currentDate.getDay() === 6) {
            currentDate.setDate(currentDate.getDate() + 2);
          }

          if (currentDate.getDay() === 0) {
            currentDate.setDate(currentDate.getDate() + 1);
          }
        }

        // if currentDate is a sunday, add a day
        if (currentDate.getDay() === 0) {
          currentDate.setDate(currentDate.getDate() + 1);
        }

        let addedDays = 0;

        while (addedDays < daysToAdd) {
          let dayOfWeek = currentDate.getDay();

          // Check if the current day is a working day (Monday-Saturday)
          if (dayOfWeek !== 0) {
            // 0 is Sunday
            addedDays++;
          }

          // Move to the next day
          currentDate.setDate(currentDate.getDate() + 1);
        }

        // if currentDate is a sunday, add a day
        if (currentDate.getDay() === 0) {
          currentDate.setDate(currentDate.getDate() + 1);
        }

        return currentDate;
      },
      init() {
        const earlyDate = this.addWorkingDays(new Date(), 2);
        const lateDate = this.addWorkingDays(new Date(), 3);
        this.earliestDate = `${earlyDate.getDate()} ${this.months[earlyDate.getMonth()]}`;
        this.latestDate = `${lateDate.getDate()} ${this.months[lateDate.getMonth()]}`;
      },
    }));

    Alpine.data('productOptions', (price, currentVariantPurchaseType) => ({
      windowWidth: window.innerWidth,
      orderType: currentVariantPurchaseType, // one-off, subscription, both
      price: price,
      get currentPrice() {
        return this.$money(this.price);
      },
      getVariantPrice(variantId) {
        if (!this.selectedSellingPlan) {
          return this.$money(this.prices[variantId]);
        }

        return this.$money(this.sellingPlanPrices[variantId][this.selectedSellingPlan]);
      },
      getVariantComparePrice(variantId) {
        return this.$money(this.comparePrices[variantId]);
      },
      options: [],
      optionsPurchaseTypes: [],
      get activeOptions() {
        return [...this.options].filter((option) => {
          return option.dataset.variantPurchaseType === this.orderType;
        });
      },
      isOptionInOrderType(purchaseType) {
        return purchaseType === this.orderType;
      },
      isSelectedOptionInActiveOptions() {
        return this.activeOptions.includes(this.selectedOption);
      },
      variantContainerHeight: 0,
      optionHeight: 0,
      optionHeights: [],
      selected: false,
      selectedOption: null,
      selectedUpsell: null,
      selectedUpsellType: null,
      selectedSellingPlan: null,
      sellingPlanPrices: {},
      prices: {},
      comparePrices: {},
      loading: false,
      get disabled() {
        if (this.loading || !this.selectedOption) {
          return true;
        }

        if (this.orderType === 'subscription' && !this.selectedSellingPlan) {
          return true;
        }

        if (!this.isSelectedOptionInActiveOptions()) {
          return true;
        }
      },
      error: null,
      init() {
        if (this.$refs.variants) {
          this.options = this.$refs.variants.querySelectorAll('div input');
          this.calculate();

          if (this.orderType === 'subscription' && this.$refs.sellingPlanPicker) {
            this.selectedSellingPlan = this.$refs.sellingPlanPicker.value;
          }

          this.options.forEach((option) => {
            if (typeof option !== 'undefined') {
              const prices = JSON.parse(option.dataset.prices);

              this.optionsPurchaseTypes.push(option.dataset.variantPurchaseType);

              this.sellingPlanPrices[option.value] = prices;
              this.prices[option.value] = option.dataset.price;
              this.comparePrices[option.value] = option.dataset.comparePrice;

              if (option.checked) {
                this.selectedOption = option;

                if (this.selectedOption.dataset.variantPurchaseType === 'subscription') {
                  this.orderType = 'subscription';
                  this.price = this.sellingPlanPrices[this.selectedOption.value][this.selectedSellingPlan];
                } else {
                  this.orderType = 'one-off';
                  this.price = this.selectedOption.dataset.price;
                }
              }

              const optContainer = option.closest('[x-ref="option"]');
              this.$nextTick().then(() => {
                optContainer.style.maxHeight = optContainer.offsetHeight + 'px';
              });
            }
          });
        }
      },
      calculate() {
        console.log('calculate');
        if (this.selected === false) {
          console.log('calculate, selected is false');
          this.height = this.$refs.variantContainer.offsetHeight;
          this.optionHeight = this.$refs.option.offsetHeight;
          this.$refs.variants.style.maxHeight = this.height + 'px';

          this.options.forEach((option, index) => {
            if (option) {
              this.optionHeights.push(option.closest('[x-ref="option"]').offsetHeight);
              this.$nextTick().then(() => {
                const optContainer = option.closest('[x-ref="option"]');
                if (optContainer.offsetHeight > this.optionHeights[index]) {
                  this.optionHeights[index] = optContainer.offsetHeight;
                }
              });
            }
          });

          this.windowWidth = window.innerWidth;
        }
      },
      optionSelected(target) {
        const opt = target.closest('[x-ref="option"]');

        if (opt.dataset.stock === '0') {
          console.log('out of stock');
          return;
        }

        this.clearUpsell();
        const selectedOptionIndex = [...this.options].indexOf(target);
        this.optionHeight = this.optionHeights[selectedOptionIndex];
        this.$refs.variants.style.maxHeight = this.optionHeight + 'px';

        this.selected = true;

        this.selectedOption = target;

        this.options.forEach((option) => {
          if (option && option.value !== target.value) {
            option.closest('[x-ref="option"]').style.overflow = 'hidden';
            option.closest('[x-ref="option"]').style.maxHeight = '0px';
            option.closest('[x-ref="option"]').style.opacity = 0;
            option.closest('[x-ref="option"]').style.borderBottom = 0;
          }
        });
      },
      expandSelection() {
        this.$nextTick().then(() => {
          this.$refs.variants.style.maxHeight = this.height + 'px';
          this.selected = false;

          this.options.forEach((option, index) => {
            if (option) {
              this.$nextTick().then(() => {
                option.closest('[x-ref="option"]').style.overflow = 'visible';
                option.closest('[x-ref="option"]').style.maxHeight = this.optionHeights[index] + 'px';
                option.closest('[x-ref="option"]').style.opacity = 1;
                option.closest('[x-ref="option"]').style.borderBottom = '';
              });
            }
          });
        });
      },
      showUpsell() {
        if (this.selectedOption?.value === this.$el.dataset.forVariant) {
          return true;
        }

        return false;
      },
      resize(e) {
        if (this.windowWidth === window.innerWidth) {
          return;
        }

        this.calculate();

        this.windowWidth = window.innerWidth;
      },
      change(e) {
        this.$refs.variantPicker.value = e.target.value;
        this.price = e.target.dataset.price;
        this.updateVariantInUrl(e.target.value);
        this.optionSelected(e.target);
      },
      optionClicked() {
        if (this.selected) {
          this.expandSelection();
        }
      },
      upsellClicked(e) {
        e.preventDefault();
        if (this.selectedUpsell === this.$el.dataset.variantId) {
          this.clearUpsell();
          return;
        }

        this.selectedUpsell = this.$el.dataset.variantId;
        this.selectedUpsellType = this.$el.dataset.upsellType;

        if (this.$el.dataset.upsellType === 'same-product') {
          console.log('same');
        }
      },
      clearUpsell() {
        this.selectedUpsell = null;
        this.selectedUpsellType = null;
      },
      updateVariantInUrl(variantId) {
        const params = new URLSearchParams(window.location.search);
        params.set('variant', variantId);
        history.replaceState({}, '', `${window.location.pathname}?${params}`);
        this.dispatchVariantChange();
      },
      dispatchVariantChange() {
        window.dispatchEvent(
          new CustomEvent('variant:change', {
            detail: {
              variant: this.$refs.variantPicker.value,
            },
          }),
        );
      },
      updatePrices() {
        if (this.selectedSellingPlan) {
          this.price = this.sellingPlanPrices[this.selectedOption.value][this.selectedSellingPlan];
        } else {
          this.price = this.selectedOption.dataset.price;
        }
      },
      reset() {
        this.expandSelection();
        this.selectedUpsell = null;
        this.updatePrices();
      },
      subscribeClick(e) {
        e.preventDefault();
        this.orderType = 'subscription';
        this.selectedSellingPlan = this.$refs.sellingPlanPicker.value;
        this.reset();
        setTimeout(() => {
          this.activeOptions[0].click();
        });
      },
      oneOffClick(e) {
        e.preventDefault();
        this.orderType = 'one-off';
        this.selectedSellingPlan = null;
        this.reset();
        setTimeout(() => {
          this.activeOptions[0].click();
        });
      },
      sellingPlanChange(e) {
        this.selectedSellingPlan = e.target.value;
        this.updatePrices();
      },
      doesVariantHaveSellingPlan(variantId) {
        const obj = this.sellingPlanPrices[variantId];
        return obj !== undefined && Object.keys(obj).length > 0;
      },
      getVariantData(variantId) {
        const variant = [...this.options].find((option) => option.value === variantId);

        if (variant) {
          return variant.dataset;
        }

        return null;
      },
      getSellingPlans() {
        const arr = [];

        if (this.$refs.sellingPlanPicker) {
          this.$refs.sellingPlanPicker.querySelectorAll('option').forEach((option) => {
            if (option.value !== 'none') {
              arr.push({
                id: option.value,
                name: option.textContent,
              });
            }
          });
        }
        return arr;
      },
      addToCart(e) {
        e.preventDefault();
        this.loading = true;
        const lineItems = [];
        let sellingPlanId = null;

        const variantData = this.getVariantData(this.$refs.variantPicker.value);

        const lineItem = {
          quantity: 1,
          id: this.$refs.variantPicker.value,
        };

        if (this.doesVariantHaveSellingPlan(this.$refs.variantPicker.value)) {
          if (this.selectedSellingPlan) {
            lineItem.selling_plan = this.selectedSellingPlan;
            sellingPlanId = this.selectedSellingPlan;
          }
        }

        if (variantData && variantData.subVariant) {
          lineItem.properties = {
            _sub_variant: `${variantData.subVariant}`,
            _selling_plan: `${this.$refs.sellingPlanPicker.options[0].value}`,
            _selling_plans: JSON.stringify(this.getSellingPlans()),
          };
        }

        if (this.selectedUpsell) {
          switch (this.selectedUpsellType) {
            case 'same-product':
              lineItem.id = this.selectedUpsell;
              lineItems.push(lineItem);

              break;
            case 'additional-product':
            default:
              lineItem.properties = {
                _upsell_variant: this.selectedUpsell,
              };

              lineItems.push(lineItem);

              const additionalLineItem = {
                quantity: 1,
                id: this.selectedUpsell,
              };

              if (this.selectedSellingPlan) {
                additionalLineItem.selling_plan = this.selectedSellingPlan;
              }

              lineItems.push(additionalLineItem);
              break;
          }
        } else {
          lineItems.push(lineItem);
        }

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: lineItems,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.status && res.status !== 200) {
              throw new Error(res.description);
            }

            this.$dispatch('cart:product-added', {
              sku: res.items[0].sku,
              variant: res.items[0].id,
              selling_plan: sellingPlanId,
            });
          })
          .catch((err) => {
            this.error = err;
          })
          .finally(() => {
            this.loading = false;
          });
      },
    }));
  });
};

export default addToCart;
